<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <h3 class="nk-block-title page-title">Reward Bonus</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Reward Bonus.</p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-3">
                            <input type="text" v-model="search" class="form-control" placeholder="Search..." />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2 mb-3">
                            <a href="javascript:void(0)" v-on:click="AddSignup()" class="btn btn-icon btn-primary btn-block"><em class="icon ni ni-plus"></em></a>
                        </div>
                    </div>

                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <table class="table table-orders">
                                    <thead>
                                        <tr class="tb-odr-item">
                                            <th class="tb-odr-info">
                                                <span class="tb-odr-id">Code</span>
                                                <span class="tb-odr-id">User</span>
                                                <span class="tb-odr-date d-none d-md-inline-block">Date</span>
                                            </th>
                                            <th class="tb-odr-amount">
                                                <span class="tb-odr-total"> Bank</span>
                                                <span class="tb-odr-status d-none d-md-inline-block">Amount</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(details) in userList" v-bind:key="details.id" class="tb-odr-item">
                                            <td class="tb-odr-info">
                                                <span class="tb-odr-id"><a href="javascript:void(0)">{{details.code}}</a></span>
                                                <span class="tb-odr-id">{{details.userName}}</span>
                                                <span class="tb-odr-date">{{getDate(details.date)}}</span>                                                
                                            </td>
                                            <td class="tb-odr-amount">
                                                <span class="tb-odr-total">
                                                    <span class="amount">{{details.bankName}} </span>
                                                </span>
                                                <span class="tb-odr-status">
                                                    ${{AmountFormat(details.amount)}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><!-- .card-inner -->
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
    </div>

</template>

<script>
    import moment from "moment";

    export default {
        name: 'UniLevelBonus',
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: true,

                loading: false,
                userList: [],

            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {
            getDate: function (date) {
                return moment(date).format('llll');
            },

            AddSignup: function () {
                this.$router.push('/AddPaymentVoucher')
            },

            AmountFormat: function (amount) {
                return parseFloat(amount).toFixed(2);
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },
            
            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Accounting/PaymentVoucherList?searchTerm=' + search + '&pageNumber=' + currentPage;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });
                }).finally(() => root.loading = false);
            },


            EditInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Bonus/UniLevelBonusDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.$router.push({
                            path: '/AddUniLevelBonus',
                            query: { data: response.data }
                        })
                    }
                });
            },

        },
        created: function () {
        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>